import { TEAM_COMMENT_TYPE } from './TeamCommentFilterType';

export const OPTION_LIST = [
  { value: TEAM_COMMENT_TYPE.WITH, label: 'Yes' },
  { value: TEAM_COMMENT_TYPE.WITHOUT, label: 'No' },
];
